import { IDictionaryUnitMap } from '../../../interfaces/Dictionary.interfaces';
import { customAxios } from '../../common/customAxios';

export const getDictionaryUnitMap = (): Promise<IDictionaryUnitMap> => {
  return customAxios.get('/dictionary/unit-map');
};
